import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import Modal from 'react-bootstrap/Modal';
import { Button, Pagination, Table } from 'react-bootstrap';
import { AnchorComponent, ButtonComponent } from "../../elements";

export default function ListerProductsTableComponent({
    thead,
    tbody,
    activeTab,
    selectedProductIds = [],
    setSelectedProductIds,
    onSingleReceived
}) {
    const { t } = useContext(TranslatorContext);

    const [alertModal, setAlertModal] = useState(false);
    const [data, setData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;

    useEffect(() => {
        setData(tbody || []);
        setCurrentPage(1);
    }, [tbody, activeTab]);

    const canEdit = ["new", "listed", "rejected", "recieved"].includes(activeTab) && activeTab !== "new";

    const handleCheckboxChange = (id) => {
        if (selectedProductIds.includes(id)) {
            setSelectedProductIds(selectedProductIds.filter(item => item !== id));
        } else {
            setSelectedProductIds([...selectedProductIds, id]);
        }
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="table-responsive w-100" style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
            <Table className="mc-table product align-middle mb-0" hover style={{ minWidth: "950px" }}>
                <thead className="mc-table-head primary">
                    <tr>
                        {thead?.map((item, index) => {
                            const isSelectCol = index === 0 && activeTab === "new";
                            return (
                                <th
                                    key={index}
                                    className="text-nowrap"
                                    style={isSelectCol ? { width: "45px", minWidth: "45px", textAlign: "center" } : {}}
                                >
                                    {t(item)}
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {currentData && currentData.length > 0 ? (
                        currentData.map((item, index) => {
                            const pImage = item?.first_img ? `${process.env.REACT_APP_IMG_URL}${item.first_img}` : "";
                            const pTitle = item?.title || "N/A";
                            const pDescribe = item?.selling_style || "N/A";
                            const pCode = item?.product_code || "N/A";
                            const style = item?.selling_style || "N/A";
                            const pQty = item?.product_qty ?? 0;

                            const pCategory = typeof item?.category === "object"
                                ? item?.category?.name
                                : (item?.category || "N/A");

                            const pBrand = typeof item?.brand === "object"
                                ? item?.brand?.name
                                : (item?.brand || "N/A");

                            const pricePrev = typeof item?.price === "object" ? item?.price?.previous : null;
                            const pricePresent = typeof item?.price === "object"
                                ? item?.price?.present
                                : (item?.sell_price_dollar || 0);
                            const auctionMinPrice = item?.auction_min_price ?? item?.auction_min_price;

                            const iconView = "visibility";
                            const iconEdit = "edit";

                            return (
                                <tr key={item?.id || index}>
                                    {activeTab === "new" && (
                                        <td className="text-center align-middle" style={{ width: "45px", minWidth: "45px" }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedProductIds.includes(item?.id)}
                                                onChange={() => handleCheckboxChange(item?.id)}
                                            />
                                        </td>
                                    )}

                                    {activeTab !== "new" && (

                                        <td
                                            className="align-middle"
                                            style={{
                                                width: "230px",
                                                minWidth: "230px",
                                                maxWidth: "230px",
                                                whiteSpace: "normal",
                                            }}
                                        >
                                            <div className="d-flex flex-column gap-1" style={{ fontSize: "12px" }}>
                                                {item.recieve_date && (
                                                    <div><strong>Receive Date:</strong><br />{item.recieve_date}</div>
                                                )}

                                                {item.listed_date && (
                                                    <div><strong>Listed Date:</strong><br />{item.listed_date}</div>
                                                )}

                                                {item.reject_date && (
                                                    <div>
                                                        <strong>Reject Date:</strong><br />
                                                        {item.reject_date}

                                                        {item.reject_reason?.reason && (
                                                            <div
                                                                className="mt-1"
                                                                style={{
                                                                    whiteSpace: "normal",
                                                                    overflowWrap: "anywhere",
                                                                    maxWidth: "100%",
                                                                }}
                                                            >
                                                                <strong>Reason:</strong><br />
                                                                {item.reject_reason.reason}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {item.assign_cheker_date && (
                                                    <div>
                                                        <strong>Assigned to Checker:</strong><br />
                                                        {item.assign_cheker_date}
                                                    </div>
                                                )}

                                                {item.approved_date && (
                                                    <div><strong>Approved Date:</strong><br />{item.approved_date}</div>
                                                )}

                                                {!item.recieve_date &&
                                                    !item.listed_date &&
                                                    !item.reject_date &&
                                                    !item.assign_cheker_date &&
                                                    !item.approved_date && <span>-</span>}
                                            </div>
                                        </td>
                                    )}

                                    {/* Product Code Column */}
                                    <td className="align-middle" style={{ width: "160px", minWidth: "160px" }}>
                                        <div className="mc-table-check d-flex flex-column align-items-start gap-1">
                                            <span className="text-break">{pCode}</span>
                                            {activeTab === "rejected" && item.rejection_reason && (
                                                <span
                                                    className="badge bg-danger-subtle text-danger text-wrap text-start mt-1"
                                                    style={{ fontSize: "11px", maxWidth: "150px", lineHeight: "1.2" }}
                                                >
                                                    <strong>{t("rejection reason")}:</strong> {item.rejection_reason}
                                                </span>
                                            )}
                                        </div>
                                    </td>

                                    {/* Title / Product Details Column */}
                                    <td className="align-middle" style={{ width: "220px", minWidth: "220px" }}>
                                        <div className="mc-table-product md d-flex align-items-center gap-2">
                                            {pImage && <img src={pImage} alt={pTitle} style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px", flexShrink: 0 }} />}
                                            <div className="mc-table-group" style={{ overflow: "hidden" }}>
                                                <h6 className="mb-0 text-truncate" title={pTitle}>{pTitle}</h6>
                                                <p className="mb-0 text-muted small text-truncate">{pDescribe}</p>
                                            </div>
                                        </div>
                                    </td>

                                    {/* Detail Column (Category, Brand, Style) */}
                                    <td className="align-middle" style={{ width: "180px", minWidth: "180px" }}>
                                        <div className="d-flex flex-column text-break" style={{ fontSize: "13px", lineHeight: "1.4" }}>
                                            <span><strong>{t("Category")}:</strong> {pCategory}</span>
                                            <span><strong>{t("Brand")}:</strong> {pBrand}</span>
                                            <span><strong>{t("Style")}:</strong> {style}</span>

                                        </div>
                                    </td>

                                    {/* Seller Price Column */}
                                    <td className="align-middle text-nowrap" style={{ width: "110px", minWidth: "110px" }}>
                                        <div className="mc-table-price">
                                            {pricePrev && <del className="text-muted me-1">${pricePrev}</del>}
                                            {pricePresent === null || pricePresent === undefined || pricePresent === "" || pricePresent === 0 || pricePresent === "0" ? (
                                                <span className="badge bg-warning text-dark fw-bold">Study</span>
                                            ) : (
                                                <p className="mb-0 fw-semibold text-success">${pricePresent}</p>
                                            )}
                                            {style === "Auction" && auctionMinPrice !== null && auctionMinPrice !== undefined && auctionMinPrice !== "" && (
                                                <p className="mb-0 small text-muted">
                                                    <strong>{t("Auction")}:</strong> ${auctionMinPrice}
                                                </p>
                                            )}
                                        </div>
                                    </td>

                                    {/* Action Column */}
                                    <td className="align-middle text-nowrap" style={{ width: "140px", minWidth: "140px" }}>
                                        <div className="mc-table-action d-flex align-items-center gap-2">
                                            <AnchorComponent
                                                to={`/lister-product-view/${item?.id || ''}`}
                                                state={{ item }}
                                                title="View"
                                                className="material-icons view"
                                            >
                                                {iconView}
                                            </AnchorComponent>

                                            {canEdit && (
                                                <AnchorComponent
                                                    to={'/lister-product-edit'}
                                                    state={{ item }}
                                                    title="Edit"
                                                    className="material-icons edit"
                                                >
                                                    {iconEdit}
                                                </AnchorComponent>
                                            )}

                                            {activeTab === "new" && (
                                                <Button
                                                    size="sm"
                                                    style={{
                                                        backgroundColor: "#28a745",
                                                        borderColor: "#28a745",
                                                        color: "#fff",
                                                        fontWeight: "500",
                                                        padding: "4px 10px",
                                                        borderRadius: "4px",
                                                        whiteSpace: "nowrap"
                                                    }}
                                                    onClick={() => onSingleReceived && onSingleReceived(item?.id)}
                                                >
                                                    Recieved
                                                </Button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={thead?.length || 8} className="text-center py-4">
                                {t("no_products_found")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {totalPages > 1 && (
                <div className="d-flex justify-content-end mt-4 px-3">
                    <Pagination>
                        <Pagination.First
                            onClick={() => handlePageChange(1)}
                            disabled={currentPage === 1}
                        />
                        <Pagination.Prev
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        />

                        {[...Array(totalPages)].map((_, index) => {
                            const pageNum = index + 1;
                            return (
                                <Pagination.Item
                                    key={pageNum}
                                    active={pageNum === currentPage}
                                    onClick={() => handlePageChange(pageNum)}
                                >
                                    {pageNum}
                                </Pagination.Item>
                            );
                        })}

                        <Pagination.Next
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        />
                        <Pagination.Last
                            onClick={() => handlePageChange(totalPages)}
                            disabled={currentPage === totalPages}
                        />
                    </Pagination>
                </div>
            )}

            <Modal show={alertModal} onHide={() => setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>{t("are_you_sure")}</h3>
                    <p>{t("want_to_delete_this_product")}</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModal(false)}>{t('close')}</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={() => setAlertModal(false)}>{t('delete')}</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    );
}